module.exports = __webpack_public_path__ + "img/icon1-1.40bfd166.svg";